"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Reward_1 = __importDefault(require("../../../Icons/Notifications/Reward"));
var NotificationItem_1 = __importDefault(require("../../NotificationItem"));
var CampaignName_1 = __importDefault(require("./CampaignName"));
var i18N = {
    en: {
        description: function (metadata) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "The gas price for the ",
            react_1.default.createElement(CampaignName_1.default, { metadata: metadata }),
            " campaign is lower than expected, and the transactions may not be processed.")); },
        title: 'Gas Price Higher Than Expected'
    },
    es: {
        description: function (metadata) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "El precio del gas para la campa\u00F1a ",
            react_1.default.createElement(CampaignName_1.default, { metadata: metadata }),
            ' ',
            "es m\u00E1s alto de lo esperado, y las transacciones pueden no ser procesadas.")); },
        title: 'Precio del Gas Más Alto de lo Esperado'
    },
    zh: {
        description: function (metadata) { return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(CampaignName_1.default, { metadata: metadata }),
            ' ',
            "\u6D3B\u52A8\u7684\u71C3\u6C14\u4EF7\u683C\u9AD8\u4E8E\u9884\u671F\uFF0C\u4EA4\u6613\u53EF\u80FD\u65E0\u6CD5\u5904\u7406\u3002")); },
        title: '燃气价格高于预期'
    }
};
/**
 * @deprecated Should start using the same component migrated to UI2.
 */
function CampaignGasPriceHigherThanExpectedNotification(_a) {
    var notification = _a.notification, locale = _a.locale;
    return (react_1.default.createElement(NotificationItem_1.default, { image: {
            image: react_1.default.createElement(Reward_1.default, { width: "48", height: "48" })
        }, timestamp: notification.timestamp, isNew: !notification.read, locale: locale },
        react_1.default.createElement("p", { className: "dcl notification-item__content-title" }, i18N[locale].title),
        react_1.default.createElement("p", { className: "dcl notification-item__content-description" }, i18N[locale].description(notification.metadata))));
}
exports.default = CampaignGasPriceHigherThanExpectedNotification;
